export default "__VITE_ASSET__DNK3uAM0__"